/*
 * Created with JetBrains WebStorm.
 * User: ggrigoriu
 * Date: 10/18/13
 * Time: 4:43 PM
 * To change this template use File | Settings | File Templates.
 */

/**
 * @class TS.domain.CommandCategory
 * @classdesc Model for a command container, usually grouped by their usage.
 * E.g: Record - ['Save', 'Close'], Filter - ['ApplyFilters', 'ResetFilters']
 */
TS.domain.CommandCategory = new Class(
    /** @lends TS.domain.CommandCategory# */
    {
        Extends: TS.domain.CommandContainer,

        Commands: null,

        initialize: function (config, owner) {
            var me = this;

            Object.append(me, config);
            me.parent(config, owner);
        },

        _setData: function (config) {
            this.parent(config);
        }
    });